import { LinkProps } from "react-router-dom";
const NoLink: React.FC<Partial<LinkProps>> = ({ children }) => <>{children}</>;
export default NoLink;
